var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Types from './types';
import { ENABLE_SELECT_PUBLISHER } from '../../utils/Constant';
var publisherListState = {
    data: null,
    error: null,
    loading: false
};
var publisherRevenueState = {
    data: null,
    error: null,
    loading: false
};
var publisherLayoutState = {
    publisherSelect: ENABLE_SELECT_PUBLISHER
};
var selectedReportPublishersState = {
    data: null,
};
var defaultSettingState = {
    data: null,
    isSaving: false,
    isSuccess: false,
    error: null
};
var publisherReducer = function (state, action) {
    if (state === void 0) { state = publisherListState; }
    switch (action.type) {
        case Types.GET_PUBLISHER_INIT:
            return {
                data: null,
                error: null,
                loading: true
            };
        case Types.GET_PUBLISHER_SUCCESS:
            return __assign(__assign({}, state), { data: action.data });
        case Types.GET_PUBLISHER_ERROR:
            return __assign(__assign({}, state), { error: action.error });
        case Types.GET_PUBLISHER_DONE:
            return __assign(__assign({}, state), { loading: false });
        default:
            return state;
    }
};
var publisherRevenueReducer = function (state, action) {
    if (state === void 0) { state = publisherRevenueState; }
    switch (action.type) {
        case Types.GET_PUBLISHER_REVENUE_INIT:
            return {
                data: null,
                error: null,
                loading: true
            };
        case Types.GET_PUBLISHER_REVENUE_SUCCESS:
            return __assign(__assign({}, state), { data: action.data });
        case Types.GET_PUBLISHER_REVENUE_ERROR:
            return __assign(__assign({}, state), { error: action.error });
        case Types.GET_PUBLISHER_REVENUE_DONE:
            return __assign(__assign({}, state), { loading: false });
        default:
            return state;
    }
};
var publisherSelectedReducer = function (state, action) {
    if (state === void 0) { state = publisherLayoutState; }
    switch (action.type) {
        case Types.PUBLISHER_DISPLAY_LAYOUT:
            return __assign(__assign({}, state), { publisherSelect: action.publisherSelect });
        default:
            return state;
    }
};
var selectedReportPublishersReducer = function (state, action) {
    if (state === void 0) { state = selectedReportPublishersState; }
    switch (action.type) {
        case Types.STORE_PUBLISHERS_REPORT_SUCCESS:
            return __assign(__assign({}, state), { data: action.data });
        default:
            return state;
    }
};
var defaultSettingReducer = function (state, action) {
    if (state === void 0) { state = defaultSettingState; }
    switch (action.type) {
        case Types.UPDATE_DEFAULT_SETTING_INIT:
            return {
                data: null,
                error: null,
                isSaving: true
            };
        case Types.UPDATE_DEFAULT_SETTING_SUCCESS:
            return __assign(__assign({}, state), { isSuccess: true, data: action.data, isSaving: false });
        case Types.UPDATE_DEFAULT_SETTING_ERROR:
            return __assign(__assign({}, state), { error: action.error, isSaving: false });
        case Types.UPDATE_DEFAULT_SETTING_STATUS:
            return __assign(__assign({}, state), { isSuccess: false });
        default:
            return state;
    }
};
var PublisherReducer = {
    publisherData: publisherReducer,
    publisherRevenueData: publisherRevenueReducer,
    publisherSelectedData: publisherSelectedReducer,
    selectedReportPublishersData: selectedReportPublishersReducer,
    defaultSetting: defaultSettingReducer,
};
export var publisherData = function (state) { return (state.publisherData.data ? state.publisherData.data : null); };
export var publisherError = function (state) { return state.publisherData.error; };
export var isLoadPublisher = function (state) { return state.publisherData.loading; };
export var publisherRevenueData = function (state) { return (state.publisherRevenueData.data ? state.publisherRevenueData.data : null); };
export var publisherRevenueError = function (state) { return state.publisherRevenueData.error; };
export var isLoadPublisherRevenue = function (state) { return state.publisherRevenueData.loading; };
export var publisherSelectedData = function (state) { return state.publisherSelectedData && state.publisherSelectedData.publisherSelect ? state.publisherSelectedData.publisherSelect : ENABLE_SELECT_PUBLISHER; };
export var getSelectedReportPublishersData = function (state) { return (state.selectedReportPublishersData.data ? state.selectedReportPublishersData.data : null); };
export var getDefaultSettingData = function (state) { return (state.defaultSetting.data ? state.defaultSetting.data : null); };
export var isSaveDefaultSettingSuccess = function (state) { return state.defaultSetting.isSuccess; };
export var getDefaultSettingError = function (state) { return state.defaultSetting.error; };
export var isSavingDefaultSetting = function (state) { return state.defaultSetting.isSaving; };
export default PublisherReducer;
